import Vue from "vue";
import DatePicker from "vue2-datepicker";
import SortedTablePlugin from "vue-sorted-table";
import Paginate from "@/components/widgets/pagination.vue";
import Customers from "@/components/widgets/delivery";
import Loading from "@/components/widgets/Loading.vue";
import moment from "moment";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>',
});
export default {
  components: {
    Customers,
    DatePicker,
    Paginate,
    Loading,
  },
  data: function () {
    return {
      uploadedFiles: [],
      selectedRows: [],
      isCustomerPopupOpen: false,
      bank_account_list: [],
      form: {
        document_no: "",
        document_date: "",
        remark: "",
        amount: null,
        bank_account_detail: null,
      },
      loading: false,
      customer: {
        customer: {
          code: "",
          name: "",
          phone_number: "",
          company_name: "",
          tax_id: "",
          address: "",
        },
        document_no: "",
      },
      busy: false,
      advanced: false,
      status: null,
      createId: null,
      openedCreate: false,
      sortDesc: false,
      totalItem: 0,
      apiStatus: "ไม่พบข้อมูล",
      doc: {
        start: null,
        end: null,
      },
      duedate: {
        start: null,
        end: null,
      },
      debtStatus: [
        { text: "On hold", value: "onhold" },
        { text: "ค้างชำระ", value: "overdue" },
        { text: "ยกเลิก", value: "cancel" },
        { text: "ชำระแล้ว", value: "success" },
      ],
      perPage: 6,
      sortBy: "name",
      currentPage: 1,
      currentData: {},
      keyword: "",
      fields: [
        {
          key: "idx",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          thStyle: { width: "5%" },
        },
        {
          key: "description",
          label: "รายละเอียด",
          sortable: false,
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          thStyle: { width: "20%" },
        },
        {
          key: "length",
          label: "ความยาว",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "quantity",
          label: "จำนวน",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "unit_name",
          label: "หน่วย",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "total_length",
          label: "ปริมาณรวม",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "unit_price",
          label: "ราคา/หน่วย",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "total_price",
          label: "ยอดชำระคืน",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: false,
          class: "text-right",
          thStyle: { width: "15%" },
        },
        {
          key: "action",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          thStyle: { width: "5%" },
        },
      ],
      items: [],
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.onInitData(this.$route.params.id);
    }
  },
  methods: {
    handleFileChange(event) {
      this.uploadedFiles = [];
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        this.uploadedFiles.push(files[i]);
      }
    },
    validateItemsAndSum() {
      let total = 0;
      let allValid = true;

      this.items.forEach((item, index) => {
        const price = parseFloat(item.total_price);
        if (isNaN(price) || price < 0) {
          allValid = false;
          // Mark item as invalid (optional if you want to show UI error)
          this.$set(item, "invalidPrice", true);
        } else {
          this.$set(item, "invalidPrice", false);
          total += price;
        }
      });

      this.form.amount = allValid ? total.toFixed(2) : ""; // รวมยอดเฉพาะถ้าถูกต้องทุกแถว
    },
    onDeliveryDocumentSelected(e) {
      this.isCustomerPopupOpen = false;

      if (e.data) {
        this.customer = e.data;
      }
    },
    validateInput(e) {
      let value = e;

      // Allow only digits and one dot (.)
      value = value.replace(/[^0-9.]/g, ""); // Remove anything except numbers and dot

      // Ensure only one dot (.) is allowed
      if (value.indexOf(".") !== value.lastIndexOf(".")) {
        value = value.slice(0, value.lastIndexOf("."));
      }

      // Update the model value
      this.amount = value;
    },
    onRowSelected(items) {
      this.selectedRows = items;

      // sum their total_price fields
      const total = items.reduce((sum, row) => {
        // make sure it's a number
        return sum + parseFloat(row.total_price || 0);
      }, 0);

      // write it back into your form
      this.form.amount = total;
    },
    onRemove(index) {
      if (index >= 0 && index < this.items.length) {
        this.items.splice(index, 1);
      }
    },
    async onInitData(uuid) {
      try {
        this.loading = true;
        this.busy = true;
        this.apiStatus = "กำลังค้นหาข้อมูล..";

        const result = await Vue.prototype.$axios.get(
          `${Vue.prototype.$host}/api/v1/document/credit-note/${uuid}`
        );

        this.loading = false;
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";

        if (result) {
          const data = result.data
          this.form.document_no = data.document_no
          this.form.document_date = new Date(data.document_date)
          this.form.bank_account_detail = data.bank_account_detail
          this.form.remark = data.remark

          const e = {
            status: true,
            data: data.delivery_document,
          };

          this.onDeliveryDocumentSelected(e);

          // BE เก็บคอลัมน์ชื่อ qty แต่หน้าตารางใช้ quantity → map ให้ตรง ไม่งั้นจำนวนหายตอนแก้ไข
          const loadedItems = (data.items || []).map((it) => ({
            ...it,
            quantity: it.quantity != null ? it.quantity : (it.qty != null ? it.qty : 0),
          }))

          this.currentData = loadedItems
          this.items = loadedItems
          this.totalItem = this.items.length

          // คำนวณยอดรวมใหม่จากรายการที่โหลดมา (เผื่อข้อมูลเก่าค่าไม่ตรง)
          this.items.forEach((_, idx) => this.updateTotals(idx))
        } else {
          this.items = [];
          this.totalItem = 0;
        }
      } catch (error) {
        this.loading = false;
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async requestCreditNote() {
      // 1. Validation เดิม
      if (!this.form.document_date) {
        this.onExceptionHandler("กรุณาเลือกกำหนดชำระ");
        return;
      }
      if (!this.form.bank_account_detail) {
        this.onExceptionHandler("กรุณาระบุช่องทางชำระเงินคืน");
        return;
      }
      if (this.customer.customer.name === "") {
        this.onExceptionHandler("กรุณาระบุบิลที่ต้องการทำรายการ");
        return;
      }
      if (this.items.length === 0) {
        this.onExceptionHandler("กรุณาใส่รายการอย่างน้อย 1 รายการ");
        return;
      }

      const invalidItem = this.items.find((item) => {
        return item.description.trim() === "" || Number(item.total_price) === 0;
      });
      if (invalidItem) {
        this.onExceptionHandler(
          "กรุณาระบุรายละเอียดและราคาสำหรับทุกรายการอย่างถูกต้อง"
        );
        return;
      }

      this.validateItemsAndSum();
      if (this.form.amount === "") {
        this.onExceptionHandler("กรุณากรอกยอดคืนในรายการให้ถูกต้อง");
        return;
      }

      // 2. สร้าง formData
      const formData = new FormData();
      formData.append("remark", this.form.remark ?? "");
      formData.append("amount", this.form.amount ?? "");
      formData.append("bank_account_detail", this.form.bank_account_detail ?? "");
      formData.append(
        "document_date",
        this.form.document_date
          ? moment(this.form.document_date).format("YYYY-MM-DD")
          : null
      );
      formData.append(
        "delivery_document_id",
        this.customer.id ?? this.customer.uuid ?? ""
      );
      formData.append("items", JSON.stringify(this.items));

      // ถ้ามี id = update, ถ้าไม่มี = create
      const isUpdate = this.$route.params.id // สมมติว่าตอนแก้ไขมี id ใน form

      try {
        this.loading = true;
        this.busy = true;

        let result;
        if (isUpdate) {
          // แก้ไข (PUT หรือ PATCH ตาม backend, ส่วนใหญ่ PUT)
          result = await Vue.prototype.$axios.post(
            `${Vue.prototype.$host}/api/v1/document/credit-note/${this.$route.params.id}?_method=PATCH`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
        } else {
          // สร้างใหม่
          result = await Vue.prototype.$axios.post(
            `${Vue.prototype.$host}/api/v1/document/credit-note`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
        }

        this.loading = false;
        this.busy = false;

        if (result) {
          this.uploadedFiles = [];
          alert(isUpdate ? "แก้ไขใบลดหนี้สำเร็จ" : "สร้างใบลดหนี้สำเร็จ");
          this.$router.push("/credit-note");
        }
      } catch (error) {
        this.loading = false;
        this.busy = false;
        this.apiStatus = "เกิดข้อผิดพลาด";
        this.onExceptionHandler(error.response?.data?.message || "เกิดข้อผิดพลาด");
      }
    },
    onopenproduct() {
      var blank_row = {
        code: "",
        code_description: "",
        description: "",
        length: "0",
        quantity: "0",
        total_length: "0",
        unit_price: "0",
        total_price: "0",
        unit_name: "",
        type: 1,
        sku_id: null,
        is_insulator: false,
        isPE: true,
        isPU: false,
        thickness: null,
        insulator_material: null,
        insulator_detail: "",
        insulator_head: "",
        insulator_tail: "",

        is_curve: false,
        curve_weight: "",
        curve_start: "",
        curve_gap: "",
        curve_repeat: "",
      };
      this.items.splice(0, 0, blank_row);
    },
    lengthChanged(event, index) {
      const value = parseFloat(event) || 0
      this.items[index].length = value
      this.updateTotals(index)
    },
    quantityChanged(event, index) {
      const value = parseFloat(event) || 0
      this.items[index].quantity = value
      this.updateTotals(index)
    },
    unitPriceChanged(event, index) {
      const value = parseFloat(event) || 0
      this.items[index].unit_price = value
      this.updateTotals(index)
    },
    updateTotals(index) {
      const item = this.items[index]
      const length = parseFloat(item.length) || 0
      const quantity = parseFloat(item.quantity) || 0
      const unitPrice = parseFloat(item.unit_price) || 0

      // ถ้าไม่ระบุความยาว ให้ใช้จำนวนเป็นปริมาณรวม
      if (length === 0) {
        item.total_length = quantity
      } else {
        item.total_length = length * quantity
      }
      item.total_price = item.total_length * unitPrice

      this.$set(this.items, index, item)

      this.form.amount = this.items.reduce(
        (sum, row) => sum + (parseFloat(row.total_price) || 0),
        0
      )
    },
  },
};
